import { analyticsEventTypes } from 'events/analytics';
import { SEARCH_RESULT_SELECTED } from '../../GladlySidekickConstants';

export default function searchResultSelected() {
  return {
    [analyticsEventTypes.SEARCH_RESULT_SELECTED]: ({ payload: { label } }) => {
      return [
        {
          eventName: SEARCH_RESULT_SELECTED,
          eventPayload: [
            {
              label,
            },
          ],
        },
      ];
    },
  };
}
